export const WORKSPACE_IDS = {
  THE_ADVOCATE: 'ws_ALi9xu9d-',
  KINDEST_PRODUCTION: 'ws_dDe_MSLeM',
  BURMA_HUMANITARIAN_MISSION: 'ws_qWgqFuYNhm',
  UNITED_PALACE_OF_SPIRITUAL_ARTS: 'ws_083z2KdH4Er',
  UNITED_PALACE_OF_ARTS_AND_CULTURE: 'ws_ec1hNLiQ7',
  PROSPERITY_INITIATIVE: 'ws_LciVd6oOI',
  NEXT_GEN_SCHOLARS: 'ws_TzA_Q-1zS',
  PLAY_MARIN: 'ws_q1mlG5y46',
  BGCSF: 'ws_DqC-D7pRvm',
  RAWSTORY: 'ws_-69jrvkvL',
  EL_NIDO: 'ws__8Szxd0Rk',
  ABOVE_AND_BEYOND: 'ws_hSz5imMiV',
  MENTAL_HEALTH_CONNECTIONS: 'ws_bbi0_XSlO',
}

// Mirrors CUSTOM_FIELDS_WORKSPACE_IDS in the API. The API is the enforcer;
// this list only hides the nav, so the two lists must stay in sync.
export const CUSTOM_FIELDS_WORKSPACE_IDS: string[] = [
  WORKSPACE_IDS.KINDEST_PRODUCTION,
  WORKSPACE_IDS.PROSPERITY_INITIATIVE,
  WORKSPACE_IDS.UNITED_PALACE_OF_ARTS_AND_CULTURE,
  WORKSPACE_IDS.PLAY_MARIN,
  WORKSPACE_IDS.ABOVE_AND_BEYOND,
]

// Soft rollout gate for the donation CSV import. The API does not check this list.
export const DONATION_IMPORT_WORKSPACE_IDS: string[] = [
  WORKSPACE_IDS.KINDEST_PRODUCTION,
  WORKSPACE_IDS.MENTAL_HEALTH_CONNECTIONS,
]

export const canImportDonations = (workspaceId?: string | null) =>
  !!workspaceId && DONATION_IMPORT_WORKSPACE_IDS.includes(workspaceId)

// Keyed by page web id (ev_...), not the numeric id.
export const EVENT_TICKETS_LABEL_OVERRIDES: Record<string, string> = {
  ev_ITbemn18e: 'Sponsorship Opportunities',
}

export const getEventTicketsLabel = (pageWebId: string) =>
  EVENT_TICKETS_LABEL_OVERRIDES[pageWebId] ?? 'Tickets'
